<template>
    <div :style="sizeStyle" v-if="todisplay" v-show="isvisible" :class="{ 'c-AudioPlayer': true, [`c-name-${name || 'unnamed'}`]: true }">
        <QCard style="text-align: center; box-shadow: none;" class="q-ma-xs">
            <QCardSection :style="VCardPadding">
                <template v-if="error">
                    <TranslationContainer :context="context" class="d-block mt-4 mb-4" style="font-size: 18px;" value="No audio file"></TranslationContainer>
                </template>
                <template v-else>
                    <div style="padding: 0">
                        <template v-if="!loaded && deferLoad && !isLoading">
                            <TranslationContainer :context="context" class="d-block mt-4 mb-4" style="font-size: 18px;" value="Press play to load the audio file"></TranslationContainer>
                        </template>
                        <template v-if="!loaded && isLoading">
                            <TranslationContainer :context="context" class="d-block mt-4 mb-4" style="font-size: 18px;" value="Generating audio file, please wait"></TranslationContainer>
                        </template>
                        <div :style="{'display': loaded ? 'block' : 'none'}">
                            <div v-show="showingVideo" style="overflow: auto;">
                                <callcorp-player ref="callcorpplayer"></callcorp-player>
                            </div>
                        
                            <div ref="waveform" id="waveform"></div>
                            <div v-if="showTimeline" ref="wavetimeline" id="wavetimeline" style="text-align: left"></div>
                            <div v-if="showSpectrogram" ref="wavespectrogram" id="wavespectrogram" style="text-align: left"></div>
                            <div v-if="showTimeline" class="mt-2" style="margin-bottom: 0px; white-space: nowrap">{{ currentTimeString }} / {{ durationString }}</div>
                        </div>
                        
                        <div style="display: block">
                            <QBtn v-if="isLoading" round flat class="q-ml-sm q-mr-sm q-mt-xs" color="secondary" :disable="true">
                                <QIcon name="mdi-loading" class="mdi-spin" style="color: #2C92FF !important; font-size: 33px;" />
                                <QTooltip anchor="top middle" self="bottom middle">{{ Translate('Loading...') }}</QTooltip>
                            </QBtn>
                            <QBtn v-else-if="!playing" round flat class="mediaButton q-ml-sm q-mr-sm q-mt-xs" color="secondary" @click="play()" :disable="!loaded && !deferLoad">
                                <QIcon name="mdi-play" />
                                <QTooltip anchor="top middle" self="bottom middle">{{ Translate('Play') }}</QTooltip>
                            </QBtn>
                            <QBtn v-else-if="playing" round flat class="mediaButton q-ml-sm q-mr-sm q-mt-xs" color="secondary" @click="pause()" :disable="!loaded">
                                <QIcon name="mdi-pause" />
                                <QTooltip anchor="top middle" self="bottom middle">{{ Translate('Pause') }}</QTooltip>
                            </QBtn>
                            <QBtn v-if="!showingVideo && videoData && videoData.length" round flat class="mediaButton q-ml-sm q-mr-sm q-mt-xs" color="secondary" @click="showVideo()" :disable="!loaded && !deferLoad">
                                <QIcon name="mdi-filmstrip" />
                                <QTooltip anchor="top middle" self="bottom middle">{{ Translate('Show video') }}</QTooltip>
                            </QBtn>
                            <QBtn v-if="downloadable" round flat class="mediaButton q-ml-sm q-mr-sm q-mt-xs" color="secondary" @click="download()" :disable="!loaded">
                                <QIcon name="mdi-download" />
                                <QTooltip anchor="top middle" self="bottom middle">{{ Translate('Download') }}</QTooltip>
                            </QBtn>
                            <QBtn v-if="deletable" round flat class="mediaButton q-ml-sm q-mr-sm q-mt-xs" color="secondary" target="_blank" @click="deleteRecording" :disable="!loaded">
                                <QIcon name="mdi-delete" />
                                <QTooltip anchor="top middle" self="bottom middle">{{ Translate('Delete') }}</QTooltip>
                            </QBtn>
                        </div>
                    </div>
                </template>
            </QCardSection>
        </QCard>
    </div>
</template>

<script>
import utils from '@/Shared/utils.jsx';
import token from '@/Services/token';
import careHelpfulFunctions from '../careHelpfulFunctions.jsx';
import BaseComponent from './BaseComponentMixin.jsx';
import api from '@/Services/api';
import TranslationContainer from './TranslationContainer.jsx';
import { QBtn, QIcon, QTooltip, QCard, QCardSection } from 'quasar';

import WaveSurfer from 'wavesurfer.js';
import RegionsPlugin from 'wavesurfer.js/dist/plugins/regions.esm.js';
import Spectrogram from 'wavesurfer.js/dist/plugins/spectrogram.esm.js'
import TimelinePlugin from 'wavesurfer.js/dist/plugins/timeline.esm.js'
import Hover from 'wavesurfer.js/dist/plugins/hover.esm.js';

function createSilentAudioBuffer(audioContext, duration = 0.1) { // Add audioContext parameter
  const buffer = audioContext.createBuffer(1, audioContext.sampleRate * duration, audioContext.sampleRate);
  const channelData = buffer.getChannelData(0);

  for (let i = 0; i < channelData.length; i++) {
    channelData[i] = 0; // Fill with silence
  }

  return buffer;
}   

export default {
    name: "AudioPlayer",
    mixins: [BaseComponent],
    components: {
        TranslationContainer,
        QBtn,
        QIcon,
        QTooltip,
        QCard,
        QCardSection
    },
    data() {
        return {
            urlEval: null,
            waveColorEval: null,
            progressColorEval: null,
            waveColor2Eval: null,
            progressColor2Eval: null,
            showSpectrogramEval: null,
            showTimelineEval: null,
            downloadableEval: null,
            deletableEval: null,
            splitChannelsEval: null,
            videoDataEval: null,
            annotationEval: null,
            deferLoadEval: null,
            wavesurfer: null,
            wavesurferRegions: null,
            isLoading: false,
            loaded: false,
            playing: false,
            played: false,
            totalDuration: 0,
            currentTime: 0,
            error: false,
            context: this,
            programaticallySeeking: false,
            callCorpPlayer: null,
            showingVideo: false
        }
    },
    created() {
    },
    //Mounted Replaced with preRenderComplete
    beforeUnmount() {
        if(this.wavesurfer)
            this.wavesurfer.destroy();
    },
    watch: {
    },
    methods: {
        preRenderComplete() {
            this.$nextTick(async () => {

                let options = {
                    container: this.$refs.waveform,
                    waveColor: this.waveColor,
                    progressColor: this.progressColor,
                    waveColor2: this.waveColor2,
                    progressColor2: this.progressColor2,
                    splitChannels: this.splitChannels,
                    backend: "MediaElement",
                    barHeight: 3,
                    height: 50,
                    plugins: [
                        Hover.create({
                            labelBackground: '#000',
                            labelColor: '#FFF',
                            lineColor: '#000',
                        })
                    ]
                };

                if(this.showTimeline){
                    options.plugins.unshift(TimelinePlugin.create({
                            container: this.$refs.wavetimeline
                        }));
                }

                if (this.showSpectrogram) {
                    options.plugins.push(Spectrogram.create({
                        container: this.$refs.wavespectrogram,
                        splitChannels: true,
                        labels: true,
                        colorMap: [[0, 0, 0.5137254901960784, 1], [0, 0.00784313725490196, 0.5176470588235295, 1], [0, 0.01568627450980392, 0.5215686274509804, 1], [0, 0.023529411764705882, 0.5294117647058824, 1], [0, 0.03137254901960784, 0.5333333333333333, 1], [0, 0.03529411764705882, 0.5372549019607843, 1], [0, 0.043137254901960784, 0.5411764705882353, 1], [0, 0.050980392156862744, 0.5490196078431373, 1], [0, 0.058823529411764705, 0.5529411764705883, 1], [0, 0.06666666666666667, 0.5568627450980392, 1], [0, 0.07450980392156863, 0.5607843137254902, 1], [0, 0.08235294117647059, 0.5647058823529412, 1], [0, 0.09019607843137255, 0.5725490196078431, 1], [0, 0.09411764705882353, 0.5764705882352941, 1], [0, 0.10196078431372549, 0.5803921568627451, 1], [0, 0.10980392156862745, 0.5843137254901961, 1], [0, 0.11764705882352941, 0.592156862745098, 1], [0, 0.12549019607843137, 0.596078431372549, 1], [0, 0.13333333333333333, 0.6, 1], [0, 0.1411764705882353, 0.6039215686274509, 1], [0, 0.14901960784313725, 0.6078431372549019, 1], [0, 0.15294117647058825, 0.615686274509804, 1], [0, 0.1607843137254902, 0.6196078431372549, 1], [0, 0.16862745098039217, 0.6235294117647059, 1], [0, 0.17647058823529413, 0.6274509803921569, 1], [0, 0.1843137254901961, 0.6313725490196078, 1], [0, 0.19215686274509805, 0.6392156862745098, 1], [0, 0.2, 0.6431372549019608, 1], [0, 0.20784313725490197, 0.6470588235294118, 1], [0, 0.21176470588235294, 0.6509803921568628, 1], [0, 0.2196078431372549, 0.6588235294117647, 1], [0, 0.22745098039215686, 0.6627450980392157, 1], [0, 0.23529411764705882, 0.6666666666666666, 1], [0, 0.24705882352941178, 0.6705882352941176, 1], [0, 0.25882352941176473, 0.6784313725490196, 1], [0, 0.27058823529411763, 0.6823529411764706, 1], [0, 0.2823529411764706, 0.6862745098039216, 1], [0, 0.29411764705882354, 0.6941176470588235, 1], [0, 0.3058823529411765, 0.6980392156862745, 1], [0.00392156862745098, 0.3176470588235294, 0.7019607843137254, 1], [0.00392156862745098, 0.32941176470588235, 0.7098039215686275, 1], [0.00392156862745098, 0.3411764705882353, 0.7137254901960784, 1], [0.00392156862745098, 0.35294117647058826, 0.7176470588235294, 1], [0.00392156862745098, 0.3686274509803922, 0.7254901960784313, 1], [0.00392156862745098, 0.3803921568627451, 0.7294117647058823, 1], [0.00392156862745098, 0.39215686274509803, 0.7333333333333333, 1], [0.00392156862745098, 0.403921568627451, 0.7411764705882353, 1], [0.00392156862745098, 0.41568627450980394, 0.7450980392156863, 1], [0.00392156862745098, 0.42745098039215684, 0.7490196078431373, 1], [0.00392156862745098, 0.4392156862745098, 0.7568627450980392, 1], [0.00392156862745098, 0.45098039215686275, 0.7607843137254902, 1], [0.00392156862745098, 0.4627450980392157, 0.7647058823529411, 1], [0.00784313725490196, 0.4745098039215686, 0.7725490196078432, 1], [0.00784313725490196, 0.48627450980392156, 0.7764705882352941, 1], [0.00784313725490196, 0.4980392156862745, 0.7803921568627451, 1], [0.00784313725490196, 0.5098039215686274, 0.788235294117647, 1], [0.00784313725490196, 0.5215686274509804, 0.792156862745098, 1], [0.00784313725490196, 0.5333333333333333, 0.796078431372549, 1], [0.00784313725490196, 0.5450980392156862, 0.803921568627451, 1], [0.00784313725490196, 0.5568627450980392, 0.807843137254902, 1], [0.00784313725490196, 0.5686274509803921, 0.8117647058823529, 1], [0.00784313725490196, 0.5803921568627451, 0.8196078431372549, 1], [0.00784313725490196, 0.592156862745098, 0.8235294117647058, 1], [0.00784313725490196, 0.6039215686274509, 0.8274509803921568, 1], [0.011764705882352941, 0.6196078431372549, 0.8352941176470589, 1], [0.011764705882352941, 0.6313725490196078, 0.8392156862745098, 1], [0.011764705882352941, 0.6431372549019608, 0.8431372549019608, 1], [0.011764705882352941, 0.6549019607843137, 0.8470588235294118, 1], [0.011764705882352941, 0.6666666666666666, 0.8549019607843137, 1], [0.011764705882352941, 0.6784313725490196, 0.8588235294117647, 1], [0.011764705882352941, 0.6901960784313725, 0.8627450980392157, 1], [0.011764705882352941, 0.7019607843137254, 0.8705882352941177, 1], [0.011764705882352941, 0.7137254901960784, 0.8745098039215686, 1], [0.011764705882352941, 0.7254901960784313, 0.8784313725490196, 1], [0.011764705882352941, 0.7372549019607844, 0.8862745098039215, 1], [0.011764705882352941, 0.7490196078431373, 0.8901960784313725, 1], [0.011764705882352941, 0.7607843137254902, 0.8941176470588236, 1], [0.01568627450980392, 0.7725490196078432, 0.9019607843137255, 1], [0.01568627450980392, 0.7843137254901961, 0.9058823529411765, 1], [0.01568627450980392, 0.796078431372549, 0.9098039215686274, 1], [0.01568627450980392, 0.807843137254902, 0.9176470588235294, 1], [0.01568627450980392, 0.8196078431372549, 0.9215686274509803, 1], [0.01568627450980392, 0.8313725490196079, 0.9254901960784314, 1], [0.01568627450980392, 0.8431372549019608, 0.9333333333333333, 1], [0.01568627450980392, 0.8549019607843137, 0.9372549019607843, 1], [0.01568627450980392, 0.8666666666666667, 0.9411764705882353, 1], [0.01568627450980392, 0.8823529411764706, 0.9490196078431372, 1], [0.01568627450980392, 0.8941176470588236, 0.9529411764705882, 1], [0.01568627450980392, 0.9058823529411765, 0.9568627450980393, 1], [0.01568627450980392, 0.9176470588235294, 0.9647058823529412, 1], [0.0196078431372549, 0.9294117647058824, 0.9686274509803922, 1], [0.0196078431372549, 0.9411764705882353, 0.9725490196078431, 1], [0.0196078431372549, 0.9529411764705882, 0.9803921568627451, 1], [0.0196078431372549, 0.9647058823529412, 0.984313725490196, 1], [0.0196078431372549, 0.9764705882352941, 0.9882352941176471, 1], [0.0196078431372549, 0.9882352941176471, 0.996078431372549, 1], [0.0196078431372549, 1, 1, 1], [0.03529411764705882, 1, 0.984313725490196, 1], [0.050980392156862744, 1, 0.9686274509803922, 1], [0.06666666666666667, 1, 0.9529411764705882, 1], [0.08235294117647059, 1, 0.9372549019607843, 1], [0.09803921568627451, 1, 0.9215686274509803, 1], [0.11372549019607843, 1, 0.9058823529411765, 1], [0.12941176470588237, 1, 0.8901960784313725, 1], [0.1450980392156863, 1, 0.8745098039215686, 1], [0.1607843137254902, 1, 0.8588235294117647, 1], [0.17647058823529413, 1, 0.8431372549019608, 1], [0.19215686274509805, 1, 0.8235294117647058, 1], [0.20784313725490197, 1, 0.807843137254902, 1], [0.2235294117647059, 1, 0.792156862745098, 1], [0.23921568627450981, 1, 0.7764705882352941, 1], [0.2549019607843137, 1, 0.7607843137254902, 1], [0.26666666666666666, 1, 0.7450980392156863, 1], [0.2823529411764706, 1, 0.7294117647058823, 1], [0.2980392156862745, 1, 0.7137254901960784, 1], [0.3137254901960784, 1, 0.6980392156862745, 1], [0.32941176470588235, 1, 0.6823529411764706, 1], [0.34509803921568627, 1, 0.6666666666666666, 1], [0.3607843137254902, 1, 0.6509803921568628, 1], [0.3764705882352941, 1, 0.6352941176470588, 1], [0.39215686274509803, 1, 0.6196078431372549, 1], [0.40784313725490196, 1, 0.6039215686274509, 1], [0.4235294117647059, 1, 0.5882352941176471, 1], [0.4392156862745098, 1, 0.5725490196078431, 1], [0.4549019607843137, 1, 0.5568627450980392, 1], [0.47058823529411764, 1, 0.5411764705882353, 1], [0.48627450980392156, 1, 0.5254901960784314, 1], [0.5019607843137255, 1, 0.5098039215686274, 1], [0.5176470588235295, 1, 0.49019607843137253, 1], [0.5333333333333333, 1, 0.4745098039215686, 1], [0.5490196078431373, 1, 0.4588235294117647, 1], [0.5647058823529412, 1, 0.44313725490196076, 1], [0.5803921568627451, 1, 0.42745098039215684, 1], [0.596078431372549, 1, 0.4117647058823529, 1], [0.611764705882353, 1, 0.396078431372549, 1], [0.6274509803921569, 1, 0.3803921568627451, 1], [0.6431372549019608, 1, 0.36470588235294116, 1], [0.6588235294117647, 1, 0.34901960784313724, 1], [0.6745098039215687, 1, 0.3333333333333333, 1], [0.6901960784313725, 1, 0.3176470588235294, 1], [0.7058823529411765, 1, 0.30196078431372547, 1], [0.7215686274509804, 1, 0.28627450980392155, 1], [0.7372549019607844, 1, 0.27058823529411763, 1], [0.7529411764705882, 1, 0.2549019607843137, 1], [0.7647058823529411, 1, 0.23921568627450981, 1], [0.7803921568627451, 1, 0.2235294117647059, 1], [0.796078431372549, 1, 0.20784313725490197, 1], [0.8117647058823529, 1, 0.19215686274509805, 1], [0.8274509803921568, 1, 0.17647058823529413, 1], [0.8431372549019608, 1, 0.1568627450980392, 1], [0.8588235294117647, 1, 0.1411764705882353, 1], [0.8745098039215686, 1, 0.12549019607843137, 1], [0.8901960784313725, 1, 0.10980392156862745, 1], [0.9058823529411765, 1, 0.09411764705882353, 1], [0.9215686274509803, 1, 0.0784313725490196, 1], [0.9372549019607843, 1, 0.06274509803921569, 1], [0.9529411764705882, 1, 0.047058823529411764, 1], [0.9686274509803922, 1, 0.03137254901960784, 1], [0.984313725490196, 1, 0.01568627450980392, 1], [1, 1, 0, 1], [1, 0.984313725490196, 0, 1], [1, 0.9686274509803922, 0, 1], [1, 0.9529411764705882, 0, 1], [1, 0.9372549019607843, 0, 1], [1, 0.9215686274509803, 0, 1], [1, 0.9058823529411765, 0, 1], [0.996078431372549, 0.8901960784313725, 0, 1], [0.996078431372549, 0.8745098039215686, 0, 1], [0.996078431372549, 0.8588235294117647, 0, 1], [0.996078431372549, 0.8431372549019608, 0, 1], [0.996078431372549, 0.8274509803921568, 0, 1], [0.996078431372549, 0.8117647058823529, 0, 1], [0.996078431372549, 0.796078431372549, 0, 1], [0.996078431372549, 0.7803921568627451, 0, 1], [0.996078431372549, 0.7647058823529411, 0, 1], [0.996078431372549, 0.7490196078431373, 0, 1], [0.996078431372549, 0.7333333333333333, 0, 1], [0.996078431372549, 0.7176470588235294, 0, 1], [0.996078431372549, 0.7019607843137254, 0, 1], [0.9921568627450981, 0.6862745098039216, 0, 1], [0.9921568627450981, 0.6705882352941176, 0, 1], [0.9921568627450981, 0.6549019607843137, 0, 1], [0.9921568627450981, 0.6392156862745098, 0, 1], [0.9921568627450981, 0.6235294117647059, 0, 1], [0.9921568627450981, 0.6078431372549019, 0, 1], [0.9921568627450981, 0.592156862745098, 0, 1], [0.9921568627450981, 0.5764705882352941, 0, 1], [0.9921568627450981, 0.5607843137254902, 0, 1], [0.9921568627450981, 0.5450980392156862, 0, 1], [0.9921568627450981, 0.5294117647058824, 0, 1], [0.9921568627450981, 0.5137254901960784, 0, 1], [0.9921568627450981, 0.5019607843137255, 0, 1], [0.9882352941176471, 0.48627450980392156, 0, 1], [0.9882352941176471, 0.47058823529411764, 0, 1], [0.9882352941176471, 0.4549019607843137, 0, 1], [0.9882352941176471, 0.4392156862745098, 0, 1], [0.9882352941176471, 0.4235294117647059, 0, 1], [0.9882352941176471, 0.40784313725490196, 0, 1], [0.9882352941176471, 0.39215686274509803, 0, 1], [0.9882352941176471, 0.3764705882352941, 0, 1], [0.9882352941176471, 0.3607843137254902, 0, 1], [0.9882352941176471, 0.34509803921568627, 0, 1], [0.9882352941176471, 0.32941176470588235, 0, 1], [0.9882352941176471, 0.3137254901960784, 0, 1], [0.984313725490196, 0.2980392156862745, 0, 1], [0.984313725490196, 0.2823529411764706, 0, 1], [0.984313725490196, 0.26666666666666666, 0, 1], [0.984313725490196, 0.25098039215686274, 0, 1], [0.984313725490196, 0.23529411764705882, 0, 1], [0.984313725490196, 0.2196078431372549, 0, 1], [0.984313725490196, 0.20392156862745098, 0, 1], [0.984313725490196, 0.18823529411764706, 0, 1], [0.984313725490196, 0.17254901960784313, 0, 1], [0.984313725490196, 0.1568627450980392, 0, 1], [0.984313725490196, 0.1411764705882353, 0, 1], [0.984313725490196, 0.12549019607843137, 0, 1], [0.984313725490196, 0.10980392156862745, 0, 1], [0.9803921568627451, 0.09411764705882353, 0, 1], [0.9803921568627451, 0.0784313725490196, 0, 1], [0.9803921568627451, 0.06274509803921569, 0, 1], [0.9803921568627451, 0.047058823529411764, 0, 1], [0.9803921568627451, 0.03137254901960784, 0, 1], [0.9803921568627451, 0.01568627450980392, 0, 1], [0.9803921568627451, 0, 0, 1], [0.9647058823529412, 0, 0, 1], [0.9490196078431372, 0, 0, 1], [0.9372549019607843, 0, 0, 1], [0.9215686274509803, 0, 0, 1], [0.9058823529411765, 0, 0, 1], [0.8901960784313725, 0, 0, 1], [0.8745098039215686, 0, 0, 1], [0.8627450980392157, 0, 0, 1], [0.8470588235294118, 0, 0, 1], [0.8313725490196079, 0, 0, 1], [0.8156862745098039, 0, 0, 1], [0.8, 0, 0, 1], [0.7843137254901961, 0, 0, 1], [0.7725490196078432, 0, 0, 1], [0.7568627450980392, 0, 0, 1], [0.7411764705882353, 0, 0, 1], [0.7254901960784313, 0, 0, 1], [0.7098039215686275, 0, 0, 1], [0.6980392156862745, 0, 0, 1], [0.6823529411764706, 0, 0, 1], [0.6666666666666666, 0, 0, 1], [0.6509803921568628, 0, 0, 1], [0.6352941176470588, 0, 0, 1], [0.6235294117647059, 0, 0, 1], [0.6078431372549019, 0, 0, 1], [0.592156862745098, 0, 0, 1], [0.5764705882352941, 0, 0, 1], [0.5607843137254902, 0, 0, 1], [0.5450980392156862, 0, 0, 1], [0.5333333333333333, 0, 0, 1], [0.5176470588235295, 0, 0, 1], [0.5019607843137255, 0, 0, 1]]
                    }));
                }

                // test data for regions
                this.wavesurferRegions = RegionsPlugin.create();
                options.plugins.push(this.wavesurferRegions);

                this.wavesurfer = WaveSurfer.create(options);
                
                this.wavesurfer.on('play', async () => {
                    this.playing = true;
                    this.isLoading = false;
                });
                this.wavesurfer.on('pause', () => {
                    this.playing = false;
                });
                this.wavesurfer.on('ready', () => {
                    this.loaded = true;
                    this.isLoading = false;
                    this.totalDuration = this.wavesurfer.getDuration();
                });
                this.wavesurfer.on('audioprocess', (seconds) => {
                    this.currentTime = this.wavesurfer.getCurrentTime();
                    this.doAudioProcessActions(seconds);
                });
                this.wavesurfer.on('seeking', (time) => {
                    this.currentTime = time;
                });
                this.wavesurfer.on('error', (e) => {
                    this.error = true
                });
                this.wavesurfer.on('decode', () => {
                    this.setupRegionsAndTags();
                });

                if (!this.deferLoad) {
                    this.loadAudio();
                } 
    
                if (this.videoData && this.videoData.length){
                    for (let vi = 0; vi < this.videoData.length; vi++){
                        if (!this.videoData[vi].src)
                            continue;

                        this.videoData[vi].src = api.standardizeUrl(this.videoData[vi].src);
                    }
                    this.callCorpPlayer = this.$refs.callcorpplayer;
                    this.callCorpPlayer.accessToken = token.AccessToken();
                }
    
                this.finishRenderHandler(this);
            });
        },
        async loadAudio() {
            if (this.controlData.OnAudioLoadStartActions)
                utils.executeAndCompileAllActions(this.controlData.OnAudioLoadStartActions, { URL: this.url }, this);

            this.isLoading = true;

            let fetchParams = {
                method: "GET",
                headers: {}
            };

            if (token.AccessToken()) {
                fetchParams.headers.access_token = token.AccessToken();
            }

            let url = this.url;
            var response = await fetch(url, fetchParams);
            if (response.ok) {
                var audioBlob = await response.blob();
                this.wavesurfer.loadBlob(audioBlob);
                if (this.controlData.OnAudioLoadSuccessActions)
                    utils.executeAndCompileAllActions(this.controlData.OnAudioLoadSuccessActions, { URL: this.url }, this);
            }
            else if (response.status === 404) {
                this.error = true;
                this.isLoading = false;
                if (this.controlData.OnAudioDoesNotExistActions)
                    utils.executeAndCompileAllActions(this.controlData.OnAudioDoesNotExistActions, { URL: this.url }, this);
            }
            else {
                this.error = true;
                this.isLoading = false;
                if (this.controlData.OnAudioLoadErrorActions)
                    utils.executeAndCompileAllActions(this.controlData.OnAudioLoadErrorActions, { URL: this.url, Status: response.status }, this);
            }
        },
        setupRegionsAndTags() {
            if (this.annotations && this.annotations.length) {

                for (let i = 0; i < this.annotations.length; i++) {
                    let contentHtml = document.createElement("div");

                    if (this.annotations[i].content) {
                        contentHtml.textContent = this.annotations[i].content;
                        contentHtml.style.cssText = this.getAnnotationLabelStyle(this.annotations[i].color);
                    }

                    let region = {
                        start: this.annotations[i].start || 0,
                        end: this.annotations[i].end || 0,
                        color: this.annotations[i].background || 'rgba(0, 0, 0, 0.5)',
                        drag: this.annotations[i].drag || false,
                        resize: this.annotations[i].resize || false,
                        contentEditable: this.annotations[i].contentEditable || false,
                        content: contentHtml
                    };

                    let newRegion = this.wavesurferRegions.addRegion(region);

                    newRegion.element.style.cssText += "color: " + this.annotations[i].color + ";";
                }
            }
        },
        getAnnotationLabelStyle(color) {
            let style = "background: white;";
            style += "color: " + color + ";";
            style += "opacity: 100%;";
            style += "border: 1px solid " + color + ";";
            style += "border-radius: 8px;";
            style += "width: fit-content;";
            style += "margin-top: 0px !important;";
            style += "margin-left: auto;";
            style += "margin-right: auto;";
            style += "padding-top: 4px;";
            style += "padding-left: 8px;";
            style += "padding-right: 8px;";
            style += "padding-bottom: 4px;";
            style += "font-size: 12px;";

            return style;
        },
        playPause() {
            if (!this.loaded)
                return;

            if (this.playing)
                this.wavesurfer.pause();
            else
                this.wavesurfer.play();
        },
        togglePlay() {
            this.wavesurfer.playPause();
        },
        deleteRecording() {
            if(this.controlData.OnDeleteActions)
                utils.executeAndCompileAllActions(this.controlData.OnDeleteActions, { URL: this.controlData.URL }, this);
        },
        Play(start, end) {
            this.play(start, end);
        },
        SeekTo(progress) {
            this.seekTo(progress);  
        },
        GetDuration() {
            return this.wavesurfer.getDuration();
        },
        Pause() {
            return this.pause();
        },
        seekTo(progress) {
            this.programaticallySeeking = true; // when manually seeking this will tell the seek events to not fire
            this.wavesurfer.seekTo(progress);
            this.programaticallySeeking = false;
        },
        async play(start, end) {
            // Defer-load only when audio is not already in memory (e.g. filmstrip
            // may have loaded it already). Key off loaded, not played.
            if (this.deferLoad && !this.loaded) {
                if (!this.isLoading)
                    await this.loadAudio();
                await this.waitForAudioReady();
            }

            if (this.error || !this.loaded)
                return;

            if (start) {
                // Our version of wavesurfer is behind so start/end sent to play does nothing.
                // This line is used in the newest implementation of this.wavesurfer.play() so we are doing it manually until we upgrade.
                this.wavesurfer.setTime(start)
            }

            if (!this.playing && !this.isLoading) {
                this.wavesurfer.play(start, end);

                if (this.callCorpPlayer)
                    this.callCorpPlayer.playing = true;
            }

            // first time audio is played execute the actions
            if (!this.played){
                this.played = true;

                if(this.controlData.OnFirstPlayActions)
                    utils.executeAndCompileAllActions(this.controlData.OnFirstPlayActions, { URL: this.url }, this);
            }
        },
        pause() {
            if (this.playing){
                this.wavesurfer.pause();

                if (this.callCorpPlayer)
                    this.callCorpPlayer.playing = false;
            }
        },
        waitForAudioReady() {
            if (this.loaded || this.error)
                return Promise.resolve();

            return new Promise((resolve) => {
                const cleanup = () => {
                    this.wavesurfer.un('ready', onReady);
                    this.wavesurfer.un('error', onError);
                };
                const onReady = () => {
                    cleanup();
                    resolve();
                };
                const onError = () => {
                    cleanup();
                    resolve();
                };
                this.wavesurfer.on('ready', onReady);
                this.wavesurfer.on('error', onError);
                if (this.loaded || this.error) {
                    cleanup();
                    resolve();
                }
            });
        },
        async showVideo() {
            // Hide filmstrip immediately; marry audio+video download on this click.
            // Wait until audio is ready so CallCorpPlayer lays out against a visible,
            // non-zero container before fetching/positioning the video tiles.
            this.showingVideo = true;

            if (!this.loaded) {
                if (!this.isLoading)
                    await this.loadAudio();
                await this.waitForAudioReady();
            }

            if (this.error || !this.loaded)
                return;

            await this.$nextTick();

            if (!this.callCorpPlayer) {
                this.callCorpPlayer = this.$refs.callcorpplayer;
                if (this.callCorpPlayer)
                    this.callCorpPlayer.accessToken = token.AccessToken();
            }

            if (this.callCorpPlayer)
                this.callCorpPlayer.videos = this.videoData;
        },
        doAudioProcessActions(seconds) {
            if (this.callCorpPlayer)
                this.callCorpPlayer.controlTime = seconds;

            if(this.programaticallySeeking)
                return;
            
            if(this.controlData.AudioProcessActions)
                utils.executeAndCompileAllActions(this.controlData.AudioProcessActions, seconds, this);
        },
        doAudioSeek(pctProgress) {
            if(this.programaticallySeeking)
                return;
            
            // convert pctProgress to seconds
            let duration = this.waveSurfer.getDuration();

            this.doAudioProcessActions(duration * pctProgress);
        },
        async download() {
            let filename = this.url.substring(this.url.lastIndexOf('/') + 1);

            // Fetch the file first so an expired recording, or one removed by an external
            // storage provider's retention, does not download the URL directly and navigate
            // the browser to an error page. A missing file returns not-found for any backend.
            let fetchParams = {
                method: "GET",
                headers: {}
            };

            if (token.AccessToken()) {
                fetchParams.headers.access_token = token.AccessToken();
            }

            let response;
            try {
                response = await fetch(this.url, fetchParams);
            } catch (e) {
                response = null;
            }

            if (!response || !response.ok) {
                this.$snotify.error('This file is no longer available for download.', 'Unavailable');
                return;
            }

            if(this.controlData.OnDownloadActions)
                utils.executeAndCompileAllActions(this.controlData.OnDownloadActions, { URL: this.url }, this);

            let blob = await response.blob();
            let objectUrl = window.URL.createObjectURL(blob);
            let link = document.createElement('a');
            link.href = objectUrl;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(objectUrl);
        }
    },
    computed: {
        url() {
            try {
                if(this.urlEval === null && this.controlData.URL) {
                    this.urlEval = utils.compile(this, this.controlData.URL);
                }
                if(this.urlEval)
                    return api.standardizeUrl(utils.evaluate(this.urlEval, this));
                return '';
            }
            catch (e) {
                utils.warn('URL could not evaluate expression: ' + this.controlData.URL + '; ' + e);
                return '';
            }
        },       
        waveColor() {
            try {
                if(this.waveColorEval === null && this.controlData.Channel0WaveColor)
                    this.waveColorEval = utils.compile(this, this.controlData.Channel0WaveColor);
                if(this.waveColorEval)
                    return utils.evaluate(this.waveColorEval, this);
                return 'blue';
            }
            catch (e) {
                utils.warn('Channel0WaveColor could not evaluate expression: ' + this.controlData.Channel0WaveColor + '; ' + e);
                return 'blue';
            }
        },
        videoData() {
            try {
                if(this.videoDataEval === null && this.controlData.VideoData)
                    this.videoDataEval = utils.compileObject(this, this.controlData.VideoData);
                if(this.videoDataEval)
                    return utils.evaluateObject(this.videoDataEval, this);
                return '';
            }
            catch (e) {
                utils.warn('VideoData could not evaluate expression: ' + this.controlData.VideoData + '; ' + e);
                return '';
            }
        },
        progressColor() {
            try {
                if(this.progressColorEval === null && this.controlData.Channel0ProgressColor)
                    this.progressColorEval = utils.compile(this, this.controlData.Channel0ProgressColor);
                if(this.progressColorEval)
                    return utils.evaluate(this.progressColorEval, this);
                return 'purple';
            }
            catch (e) {
                utils.warn('Channel0ProgressColor could not evaluate expression: ' + this.controlData.Channel0ProgressColor + '; ' + e);
                return 'purple';
            }
        },
        waveColor2() {
            try {
                if(this.waveColorEval === null && this.controlData.Channel1WaveColor)
                    this.waveColorEval = utils.compile(this, this.controlData.Channel1WaveColor);
                if(this.waveColorEval)
                    return utils.evaluate(this.waveColorEval, this);
                return 'blue';
            }
            catch (e) {
                utils.warn('Channel1WaveColor could not evaluate expression: ' + this.controlData.Channel1WaveColor + '; ' + e);
                return 'blue';
            }
        },
        progressColor2() {
            try {
                if(this.progressColorEval === null && this.controlData.Channel1ProgressColor)
                    this.progressColorEval = utils.compile(this, this.controlData.Channel1ProgressColor);
                if(this.progressColorEval)
                    return utils.evaluate(this.progressColorEval, this);
                return 'purple';
            }
            catch (e) {
                utils.warn('Channel1ProgressColor could not evaluate expression: ' + this.controlData.Channel1ProgressColor + '; ' + e);
                return 'purple';
            }
        },
        showSpectrogram() {
            try {
                if(this.showSpectrogramEval === null && this.controlData.ShowSpectrogram)
                    this.showSpectrogramEval = utils.compileObject(this, this.controlData.ShowSpectrogram);
                if(this.showSpectrogramEval)
                    return utils.evaluateObject(this.showSpectrogramEval, this);
                return false;
            }
            catch (e) {
                utils.warn('ShowSpectrogram could not evaluate expression: ' + this.controlData.ShowSpectrogram + '; ' + e);
                return false;
            }
        },
        showTimeline() {
            try {
                if(this.showTimelineEval === null && this.controlData.ShowTimeline)
                    this.showTimelineEval = utils.compileObject(this, this.controlData.ShowTimeline);
                if(this.showTimelineEval)
                    return utils.evaluateObject(this.showTimelineEval, this);
                return false;
            }
            catch (e) {
                utils.warn('ShowTimeline could not evaluate expression: ' + this.controlData.ShowTimeline + '; ' + e);
                return false;
            }
        },
        splitChannels() {
            try {
                if(this.splitChannelsEval === null && this.controlData.SplitChannels)
                    this.splitChannelsEval = utils.compileObject(this, this.controlData.SplitChannels);
                if(this.splitChannelsEval)
                    return utils.evaluateObject(this.splitChannelsEval, this);
                return false;
            }
            catch (e) {
                utils.warn('SplitChannels could not evaluate expression: ' + this.controlData.SplitChannels + '; ' + e);
                return false;
            }
        },
        downloadable() {
            try {
                if(this.downloadableEval === null && this.controlData.Downloadable)
                    this.downloadableEval = utils.compileObject(this, this.controlData.Downloadable);
                if(this.downloadableEval)
                    return utils.evaluateObject(this.downloadableEval, this);
                return false || this.controlData.Downloadable === undefined;
            }
            catch (e) {
                utils.warn('Downloadable could not evaluate expression: ' + this.controlData.Downloadable + '; ' + e);
                return false;
            }
        },
        annotations() {
            try {
                if (this.annotationEval === null && this.controlData.AnnotationsExpression)
                    this.annotationEval = utils.compileExpression(this, this.controlData.AnnotationsExpression);
                if (this.annotationEval)
                    return utils.evaluate(this.annotationEval, this);
                return [];
            }
            catch (e) {
                utils.warn('AnnotationsExpression could not evaluate expression: ' + this.controlData.AnnotationsExpression + '; ' + e);
                return false;
            }
        },
        deletable() {
            if(!careHelpfulFunctions.hasRole('Admin'))
                return false;
            
            try {
                if(this.deletableEval === null && this.controlData.Deletable)
                    this.deletableEval = utils.compileObject(this, this.controlData.Deletable);
                if(this.deletableEval)
                    return utils.evaluateObject(this.deletableEval, this);
                return false;
            }
            catch (e) {
                utils.warn('Deletable could not evaluate expression: ' + this.controlData.Deletable + '; ' + e);
                return false;
            }
        },
        deferLoad() {
            try {
                if (this.deferLoadEval === null && this.controlData.DeferLoad )
                    this.deferLoadEval = utils.compileObject(this, this.controlData.DeferLoad );
                if (this.deferLoadEval)
                    return utils.evaluateObject(this.deferLoadEval, this);
                return false;
            }
            catch (e) {
                utils.warn('DeferLoad could not evaluate expression: ' + this.controlData.DeferLoad  + '; ' + e);
                return false;
            }
        },
        currentTimeString() {
            return careHelpfulFunctions.formatTotalTime(this.currentTime);
        },
        durationString() {
            return careHelpfulFunctions.formatTotalTime(this.totalDuration);
        },
        WaveSurfer() {
            return this.wavesurfer;
        },
        VCardPadding() {
            return { padding: "0 !important" };
        },
        sizeStyle() {
            const sizeOptions = { ...this.getSizeDefaults(), ...this.sizeOptions };
            return { ...utils.getSize(sizeOptions, this.parentType, this.$parent), overflow: 'hidden', padding: 8 };
        }
    }
};
</script>

<style>
</style>
